"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInvoiceDraftsDto = exports.CreateInvoiceDraftFromInvoiceDto = exports.CreateInvoiceDraftFromTransactionDto = exports.IssueInvoiceDraftDto = exports.InvoiceDraftVersionDto = exports.UpdateInvoiceDraftDto = exports.CreateInvoiceDraftDto = exports.INVOICE_FISCAL_REGIMES = exports.INVOICE_DRAFT_STATUSES = exports.INVOICE_DRAFT_KINDS = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const cursor_pagination_1 = require("../cursor-pagination");
const invoice_line_dto_1 = require("./invoice-line-dto");
const invoice_party_dto_1 = require("./invoice-party-dto");
exports.INVOICE_DRAFT_KINDS = [
    "standard",
    "partial_rectification",
    "cancel_and_replace",
];
exports.INVOICE_DRAFT_STATUSES = [
    "draft",
    "ready",
    "issuing",
    "issued",
    "discarded",
    "failed",
];
exports.INVOICE_FISCAL_REGIMES = ["domestic", "intra_eu", "extra_eu"];
class CreateInvoiceDraftDto {
    kind;
    issuer;
    recipient;
    operationDate;
    fiscalRegime;
    lines;
    deliveryEmail;
    sendOnIssue = true;
    notes;
    originalInvoiceId;
    rectificationReason;
    sourceTransactionId;
}
exports.CreateInvoiceDraftDto = CreateInvoiceDraftDto;
__decorate([
    (0, class_validator_1.IsEnum)(exports.INVOICE_DRAFT_KINDS),
    __metadata("design:type", String)
], CreateInvoiceDraftDto.prototype, "kind", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => invoice_party_dto_1.InvoicePartyInputDto),
    __metadata("design:type", invoice_party_dto_1.InvoicePartyInputDto)
], CreateInvoiceDraftDto.prototype, "issuer", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => invoice_party_dto_1.InvoicePartyInputDto),
    __metadata("design:type", invoice_party_dto_1.InvoicePartyInputDto)
], CreateInvoiceDraftDto.prototype, "recipient", void 0);
__decorate([
    (0, class_validator_1.IsISO8601)({ strict: true }),
    __metadata("design:type", String)
], CreateInvoiceDraftDto.prototype, "operationDate", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(exports.INVOICE_FISCAL_REGIMES),
    __metadata("design:type", String)
], CreateInvoiceDraftDto.prototype, "fiscalRegime", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => invoice_line_dto_1.InvoiceLineInputDto),
    __metadata("design:type", Array)
], CreateInvoiceDraftDto.prototype, "lines", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)(),
    __metadata("design:type", String)
], CreateInvoiceDraftDto.prototype, "deliveryEmail", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Object)
], CreateInvoiceDraftDto.prototype, "sendOnIssue", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateInvoiceDraftDto.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((draft) => draft.kind !== "standard"),
    __metadata("design:type", String)
], CreateInvoiceDraftDto.prototype, "originalInvoiceId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((draft) => draft.kind !== "standard"),
    __metadata("design:type", String)
], CreateInvoiceDraftDto.prototype, "rectificationReason", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CreateInvoiceDraftDto.prototype, "sourceTransactionId", void 0);
class UpdateInvoiceDraftDto {
    expectedVersion;
    issuer;
    recipient;
    operationDate;
    fiscalRegime;
    lines;
    deliveryEmail;
    sendOnIssue;
    notes;
    rectificationReason;
}
exports.UpdateInvoiceDraftDto = UpdateInvoiceDraftDto;
__decorate([
    (0, class_validator_1.IsNumber)({ allowInfinity: false, allowNaN: false }),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], UpdateInvoiceDraftDto.prototype, "expectedVersion", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => invoice_party_dto_1.InvoicePartyInputDto),
    __metadata("design:type", invoice_party_dto_1.InvoicePartyInputDto)
], UpdateInvoiceDraftDto.prototype, "issuer", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => invoice_party_dto_1.InvoicePartyInputDto),
    __metadata("design:type", invoice_party_dto_1.InvoicePartyInputDto)
], UpdateInvoiceDraftDto.prototype, "recipient", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsISO8601)({ strict: true }),
    __metadata("design:type", String)
], UpdateInvoiceDraftDto.prototype, "operationDate", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(exports.INVOICE_FISCAL_REGIMES),
    __metadata("design:type", String)
], UpdateInvoiceDraftDto.prototype, "fiscalRegime", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => invoice_line_dto_1.InvoiceLineInputDto),
    __metadata("design:type", Array)
], UpdateInvoiceDraftDto.prototype, "lines", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEmail)(),
    __metadata("design:type", String)
], UpdateInvoiceDraftDto.prototype, "deliveryEmail", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], UpdateInvoiceDraftDto.prototype, "sendOnIssue", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UpdateInvoiceDraftDto.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], UpdateInvoiceDraftDto.prototype, "rectificationReason", void 0);
class InvoiceDraftVersionDto {
    expectedVersion;
}
exports.InvoiceDraftVersionDto = InvoiceDraftVersionDto;
__decorate([
    (0, class_validator_1.IsNumber)({ allowInfinity: false, allowNaN: false }),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], InvoiceDraftVersionDto.prototype, "expectedVersion", void 0);
class IssueInvoiceDraftDto extends InvoiceDraftVersionDto {
    idempotencyKey;
    sendOnIssue;
}
exports.IssueInvoiceDraftDto = IssueInvoiceDraftDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], IssueInvoiceDraftDto.prototype, "idempotencyKey", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], IssueInvoiceDraftDto.prototype, "sendOnIssue", void 0);
class CreateInvoiceDraftFromTransactionDto {
    transactionId;
}
exports.CreateInvoiceDraftFromTransactionDto = CreateInvoiceDraftFromTransactionDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateInvoiceDraftFromTransactionDto.prototype, "transactionId", void 0);
class CreateInvoiceDraftFromInvoiceDto {
    invoiceId;
    kind;
}
exports.CreateInvoiceDraftFromInvoiceDto = CreateInvoiceDraftFromInvoiceDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateInvoiceDraftFromInvoiceDto.prototype, "invoiceId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(["partial_rectification", "cancel_and_replace"]),
    __metadata("design:type", String)
], CreateInvoiceDraftFromInvoiceDto.prototype, "kind", void 0);
class SearchInvoiceDraftsDto extends cursor_pagination_1.CursorPaginationOptions {
    status;
    kind;
}
exports.SearchInvoiceDraftsDto = SearchInvoiceDraftsDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(exports.INVOICE_DRAFT_STATUSES),
    __metadata("design:type", String)
], SearchInvoiceDraftsDto.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(exports.INVOICE_DRAFT_KINDS),
    __metadata("design:type", String)
], SearchInvoiceDraftsDto.prototype, "kind", void 0);
